<template>
  <div class="UIModalHeader">
    <div class="UIModalHeader__title">
      <slot />
    </div>

    <UIButtonIcon
      v-if="showClose"
      theme="white"
      class="UIModalHeader__close-icon"
      icon="close"
      @click="$emit('close')"
    />
  </div>
</template>

<script lang="ts" setup>
import UIButtonIcon from '../buttons/UIButtonIcon.vue'

defineEmits(['close'])
withDefaults(
  defineProps<{
    showClose?: boolean
  }>(),
  {
    showClose: true,
  },
)
</script>

<style scoped lang="scss">
.UIModalHeader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--padding-header, 1rem 1.5rem);

  .UIModalHeader__title {
    @include font-size-16px;
    font-weight: 600;
    color: $color-neutral-150;
  }

  .UIModalHeader__close-icon {
    --icon-size: 1rem;
    --icon-color: #{$color-neutral-150};
  }
}
</style>
